export type CarMake = {
  href: string;
  name: string;
};

export const carMakesList: CarMake[] = [
  {
    name: 'Alfa Romeo',
    href: 'alfa-romeo',
  },
  {
    name: 'Audi',
    href: 'audi',
  },
  {
    name: 'Austin',
    href: 'austin',
  },
  {
    name: 'BMW',
    href: 'bmw',
  },
  {
    name: 'Chevrolet',
    href: 'chevrolet',
  },
  {
    name: 'Chrysler',
    href: 'chrysler',
  },
  {
    name: 'Citroen',
    href: 'citroen',
  },
  {
    name: 'Dacia',
    href: 'dacia',
  },
  {
    name: 'Daewoo',
    href: 'daewoo',
  },
  {
    name: 'Dodge',
    href: 'dodge',
  },
  {
    name: 'DS',
    href: 'ds',
  },
  {
    name: 'Fiat',
    href: 'fiat',
  },
  {
    name: 'Ford',
    href: 'ford',
  },
  {
    name: 'Honda',
    href: 'honda',
  },
  {
    name: 'Hyundai',
    href: 'hyundai',
  },
  {
    name: 'Infiniti',
    href: 'infiniti',
  },
  {
    name: 'Isuzu',
    href: 'isuzu',
  },
  {
    name: 'Jaguar',
    href: 'jaguar',
  },
  {
    name: 'Jeep',
    href: 'jeep',
  },
  {
    name: 'Kia',
    href: 'kia',
  },
  {
    name: 'Land Rover',
    href: 'landrover',
  },
  {
    name: 'Lexus',
    href: 'lexus',
  },
  {
    name: 'Lotus',
    href: 'lotus',
  },
  {
    name: 'Mazda',
    href: 'mazda',
  },
  {
    name: 'Mercedes',
    href: 'mercedes',
  },
  {
    name: 'MG',
    href: 'mg',
  },
  {
    name: 'Mini',
    href: 'mini',
  },
  {
    name: 'Mitsubishi',
    href: 'mitsubishi',
  },
  {
    name: 'Nissan',
    href: 'nissan',
  },
  {
    name: 'Peugeot',
    href: 'peugeot',
  },
  {
    name: 'Porsche',
    href: 'porsche',
  },
  {
    name: 'Proton',
    href: 'proton',
  },
  {
    name: 'Renault',
    href: 'renault',
  },
  {
    name: 'Rover',
    href: 'rover',
  },
  {
    name: 'Saab',
    href: 'saab',
  },
  {
    name: 'Seat',
    href: 'seat',
  },
  {
    name: 'Skoda',
    href: 'skoda',
  },
  {
    name: 'Smart',
    href: 'smart',
  },
  {
    name: 'Subaru',
    href: 'subaru',
  },
  {
    name: 'Suzuki',
    href: 'suzuki',
  },
  {
    name: 'Tesla',
    href: 'tesla',
  },
  {
    name: 'Toyota',
    href: 'toyota',
  },
  {
    name: 'Vauxhall',
    href: 'vauxhall',
  },
  {
    name: 'Volkswagen',
    href: 'volkswagen',
  },
  {
    name: 'Volvo',
    href: 'volvo',
  },
];
